import { ScanResultType } from "./SpaceScanner.types";

export const LOCKED_RESULT_TYPES: ScanResultType[] = [
  "booking_locked",
  "booking_locked_deposit",
  "booking_locked_preorder",
  "booking_locked_manual"
];

export const EXCLUDED_RESULT_TYPES: ScanResultType[] = [
  "booking_excluded",
  "booking_started",
  "booking_guestlist",
  "booking_left",
  "booking_waitlisted",
  "booking_noshow",
  "area_closed"
];

export const LOCKED_OR_EXCLUDED_RESULT_TYPES: ScanResultType[] = [
  ...LOCKED_RESULT_TYPES,
  ...EXCLUDED_RESULT_TYPES
];

export const isUnassignedResult = (result?: string): boolean =>
  !!result &&
  (result.startsWith("unassigned_") ||
    result === "no_area_found" ||
    result === "booking_in_progress_unassigned");

export const RESULT_TYPE_TEXT: Partial<
  Record<ScanResultType, { shortReason: string; explanation: string }>
> = {
  no_better_area: {
    shortReason: "No better area was found",
    explanation: "No changes suggested for this booking."
  },
  booking_started: {
    shortReason: "Booking has already started",
    explanation: "This booking has already started and cannot be moved."
  },
  booking_locked: {
    shortReason: "Booking is locked",
    explanation: "This booking is locked and cannot be moved."
  },
  booking_excluded: {
    shortReason: "Booking is excluded",
    explanation: "This booking is excluded from optimisation."
  },
  booking_guestlist: {
    shortReason: "This is a guestlist booking",
    explanation: "Guestlist bookings are excluded from optimisation."
  },
  preferred_area_found: {
    shortReason: "Already in preferred area",
    explanation: "No changes suggested for this booking."
  },
  booking_left: {
    shortReason: "Booking has left",
    explanation: "This booking has left the venue."
  },
  booking_waitlisted: {
    shortReason: "Booking is on the waitlist",
    explanation: "Waitlisted bookings are not included in optimisation."
  },
  booking_noshow: {
    shortReason: "Booking is marked as no-show",
    explanation: "This booking is marked as a no-show."
  },
  area_closed: {
    shortReason: "Target area is closed",
    explanation: "The target area is currently closed."
  },
  booking_locked_deposit: {
    shortReason: "Booking is locked (deposit paid)",
    explanation: "This booking is locked and cannot be moved."
  },
  booking_locked_preorder: {
    shortReason: "Booking is locked (pre-order placed)",
    explanation: "This booking is locked and cannot be moved."
  },
  booking_locked_manual: {
    shortReason: "Booking is manually locked",
    explanation: "This booking is locked and cannot be moved."
  },
  unassigned_no_tables_configured: {
    shortReason: "No tables configured for this booking type",
    explanation: "No tables are configured for this booking type."
  },
  unassigned_table_too_small: {
    shortReason: "No table large enough for party size",
    explanation: "No table is large enough for this party size."
  },
  unassigned_rule_conflict: {
    shortReason: "Booking rules prevent table assignment",
    explanation: "Booking rules prevent table assignment."
  },
  unassigned_no_availability: {
    shortReason: "No tables available at this time",
    explanation: "No tables are available at this time."
  },
  no_area_found: {
    shortReason: "No suitable area found",
    explanation: "No area could accommodate this booking."
  },
  booking_in_progress_unassigned: {
    shortReason: "Booking in progress (unassigned)",
    explanation: "This booking is in progress but has no table assigned."
  }
};
